/**
 * Formata o texto de exibição da promoção "Leve X Pague Y" baseado no tipo de desconto.
 *
 * STORY-NEW-039: Ajustes na Exibição de Texto "Leve X Pague Y"
 *
 * Regras:
 * - Desconto integral (tipos 0, 3, 7, 8): "Leve X pague Y"
 * - Desconto percentual ou fixo (tipos 1, 2, 4, 5): "Leve X e tenha desconto em Y"
 *
 * @param takeQuantity - Quantidade "Leve"
 * @param payQuantity - Quantidade "Pague" ou quantidade com desconto
 * @param discountType - Tipo de desconto (0-8)
 * @returns Texto formatado da promoção
 */
export function formatPromotionText(
  takeQuantity: number,
  payQuantity: number,
  discountType: number
): string {
  // Tipos de desconto integral: 0, 3, 7, 8
  // 0 = Desconto integral na 2ª peça (mesmo item)
  // 3 = Desconto integral (itens da lista)
  // 7 = Brinde - escolher item da lista
  // 8 = Brinde - mesmo item
  const integralTypes = [0, 3, 7, 8];

  if (integralTypes.includes(discountType)) {
    return `Leve ${takeQuantity} pague ${payQuantity}`;
  }

  // Tipos de desconto percentual/fixo: 1, 2, 4, 5
  // 1 = Percentual na 2ª peça (mesmo item)
  // 2 = Valor fixo de desconto (mesmo item)
  // 4 = Percentual (itens da lista)
  // 5 = Valor fixo de desconto (itens da lista)
  return `Leve ${takeQuantity} e tenha desconto em ${payQuantity}`;
}

/**
 * Retorna o texto curto para badges/resumos
 *
 * @param takeQuantity - Quantidade "Leve"
 * @param payQuantity - Quantidade "Pague"
 * @param discountType - Tipo de desconto
 * @returns Texto curto formatado
 */
export function formatPromotionTextShort(
  takeQuantity: number,
  payQuantity: number,
  discountType: number
): string {
  const integralTypes = [0, 3, 7, 8];

  if (integralTypes.includes(discountType)) {
    return `${takeQuantity}x${payQuantity}`;
  }

  return `${takeQuantity} (-${payQuantity})`;
}

/**
 * Verifica se o tipo de desconto é integral
 *
 * @param discountType - Tipo de desconto
 * @returns true se for desconto integral
 */
export function isIntegralDiscount(discountType: number): boolean {
  return [0, 3, 7, 8].includes(discountType);
}
